<div class="time-input">
  <input type="number" min="0" max="23" maxlength="2" placeholder="{{lang.tra('lbl_hour')}}" class="input is-small" [formControl]="hour"  >
  <span class="time-seperator">:</span>
  <input type="number" min="0" max="59" maxlength="2" placeholder="Min."  class="input is-small"  [formControl]="minutes"  >
  <div class="select is-small">
    <select [formControl]="period" >
      <option value=""></option>    
      <option [value]="Periods.AM">{{lang.tra('lbl_am')}}</option>    
      <option [value]="Periods.PM">{{lang.tra('lbl_pm')}}</option>    
    </select>
  </div>
</div>
